/* src/app/common/components/range-picker/range-picker.component.scss */
.range-input {
  --padding-start: 0.5rem;
  --padding-end: 0.5rem;
  cursor: pointer;
  width: 100%;
  max-width: 100%;
}
.range-popover {
  --width: 90vw;
  --max-height: 90vh;
  --border-radius: 8px;
  padding: 0;
}
@media (min-width: 576px) {
  .range-popover {
    --width: 500px;
  }
}
@media (min-width: 768px) {
  .range-popover {
    --width: 600px;
  }
}
@media (min-width: 992px) {
  .range-popover {
    --width: 700px;
  }
}
.picker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--ion-color-light-shade);
}
.picker-title {
  font-size: 1rem;
  font-weight: 600;
}
.picker-body {
  display: flex;
  flex-wrap: wrap;
  padding: 0.5rem;
  gap: 1rem;
}
.picker-column {
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
}
@media (min-width: 576px) {
  .picker-column {
    flex: 1 1 45%;
  }
}
.picker-column-header {
  font-size: 0.9rem;
  color: var(--ion-color-medium);
}
.picker-footer {
  padding: 0.25rem 1rem;
  border-top: 1px solid var(--ion-color-light-shade);
}
.format-label {
  font-size: 14px;
  white-space: nowrap;
  font-weight: 600;
  font-family:
    Arial,
    Helvetica,
    sans-serif;
}
.calendar-icon-btn {
  margin: 0 0.4rem 0 0 !important;
}
.close-icon-btn {
  margin: 0 0 0 0.4rem !important;
}
/*# sourceMappingURL=range-picker.component.css.map */
